import {
Component,
Inject,
// Input,
inject,
OnInit,
// Signal,
signal,
WritableSignal
} from '@angular/core';
import {
FormBuilder,
FormGroup,
ReactiveFormsModule,
Validators
} from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggle,MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ActivatedRoute,RouterLink } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import {
AuthenticationServiceToken,
RepositoryServiceToken,
} from '../../services';
import { AuthenticationService } from '../../services/auth.service';
import { CommunityAuthService } from '../../services/community-auth.service';
import { IRepositoryService } from '../../services/i';
import {
UserViewModel
} from '../../view-models';
import { IdentityClaimsModel } from '../../view-models/identity-claims.model';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'app-manage-settings',
  templateUrl: './manage-settings.component.html',
  styleUrls: ['./manage-settings.component.scss'],
  imports: [
    HeaderComponent,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatRadioModule,
    RouterLink,
    MatInputModule,
    MatButtonModule,
    MatSlideToggle,
    MatSlideToggleModule,
  ],
  standalone: true,
})
// Purpose: expose the user's own User object for editing (contains their preferences).
export class ManageSettingsComponent implements OnInit {
  user: UserViewModel;
  public userFullName: WritableSignal<string> = signal('');
  hasDailyEmailSummary = false;
  public communityAuthService: CommunityAuthService = inject(CommunityAuthService);
  settingsForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    @Inject(RepositoryServiceToken) private repo: IRepositoryService,
    @Inject(AuthenticationServiceToken) private auth: AuthenticationService,
    @Inject(AuthenticationService) public authenticationService: AuthenticationService,
    private route: ActivatedRoute
  ) {
    this.user = this.route.snapshot.data.user;
    this.userFullName.set(this.user.FullName);
    // console.log(' authenticationservice', this.authenticationService);
    // console.log(' communityservice', this.communityAuthService);
    // console.log(' roles', this.authenticationService.roles);
  }

  ngOnInit() {
    // this.keywords.setValue("");
    // let filter = new UserFilterViewModel();
    // filter.Type = UserFilterType.HawkId;
    // filter.HawkId = this.auth.username;
    // filter.Page = 0;
    // filter.PageSize = 1;

    // this.repo.Page(UserViewModel, filter).subscribe(users => {
    //   console.log('first users', users);
    //   this.updateUI(users[0]);
    // });
    // this.repo.Page(UserViewModel, filter).subscribe(value => {
    //   console.log('here are the users', value);
    // });
    // this.setUser();
    this.setupForm();
    this.updateUI(this.user);
  }

  updateUI(user: UserViewModel) {
    this.user = user;
    this.settingsForm.get('Email').setValue(this.user?.Email ?? '');
    this.settingsForm.get('EmailNotifications').setValue(this.user.EmailNotifications);
  }

  async save() {
    this.user.Email = this.settingsForm.value.Email;
    this.user.EmailNotifications = this.settingsForm.value.EmailNotifications;
    this.updateUI(await firstValueFrom(this.repo.Update(UserViewModel, this.user)));
  }

  private setUser(): void {
    try {
      // console.log(this.authenticationService.isAuthenticated, 'aaaaaaaa');
      if (this.communityAuthService.isAuthenticated) {
        this.user = this.user ?? new UserViewModel();
        const tempIC: IdentityClaimsModel = this.authenticationService
          .identityClaims as IdentityClaimsModel;
        this.user.First =
          (this.user.First ?? '').trim() === ''
            ? (tempIC.given_name ?? '')
            : this.user.First;
        this.user.Last =
          (this.user.Last ?? '').trim() === ''
            ? (tempIC.family_name ?? '')
            : this.user.Last;
        this.user.HawkId =
          (this.user.HawkId ?? '').trim() === ''
            ? (tempIC.uiowahawkid ?? '')
            : this.user.HawkId;
        this.user.Email =
          (this.user.Email ?? '').trim() === ''
            ? (tempIC.email ?? '')
            : this.user.Email;
        this.userFullName.set(tempIC?.name ?? '');
      }
    } catch (error) {
      console.error(error);
    }
  }

  private setupForm(): void {
    this.settingsForm = this.fb.group({
      Email: [this.user.Email, [Validators.required]],
      EmailNotifications: [this.user.EmailNotifications ],
    });
  }
}
